import React from "react";
import { render } from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Redux/store.js";
import App from "./App.jsx";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "./ThemeConfig";

render(
  <React.StrictMode>
    <Provider store={store}>
      <Router basename="/iluminarte">
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
